import { Grid } from '@mui/material';
import React from 'react';
import useStyles from "../../../../style/js-style/containers/thirdparties/sheet/TPSheetStyle.js";
import ThirdpartyContext from 'containers/thirdparties/thirdparty-sheet/Context';

function ContexteSection({ thirdpartyId, display, thirdpartyActiveDossiers}) {
  const { classes } = useStyles();

  return display && (
    <Grid item xs={12} className={classes.tpItem} id={"contextes"}>
        <ThirdpartyContext thirdpartyId={thirdpartyId} dossiers={thirdpartyActiveDossiers}/>
    </Grid>
  );
}

export default ContexteSection;
